import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importations des fichiers de traduction (on va les créer juste après)
import fr from './locales/fr.json';
import en from './locales/en.json';
import pt from './locales/pt.json';
import es from './locales/es.json';
import de from './locales/de.json';
import it from './locales/it.json';

const validLangs = ['fr', 'en', 'pt', 'es', 'de', 'it'];
const pathParts = typeof window !== 'undefined' ? window.location.pathname.split('/').filter(Boolean) : [];
const urlLang = pathParts[0] && validLangs.includes(pathParts[0]) ? pathParts[0] : null;
const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
const isSeoRoute = pathname === '/' || pathname.includes('/blog') || pathname.includes('/faq') || pathname.includes('/glossary') || pathname.includes('/features') || pathname.includes('/cgu') || pathname.includes('/mentions-legales') || pathname.includes('/contact') || pathname.includes('/trade');
const initialLang = isSeoRoute ? (urlLang || 'fr') : (urlLang || undefined);

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: initialLang,
        resources: {
            fr: { translation: fr },
            en: { translation: en },
            pt: { translation: pt },
            es: { translation: es },
            de: { translation: de },
            it: { translation: it }
        },
        fallbackLng: 'fr',
        interpolation: {
            escapeValue: false
        },
        detection: {
            order: ['path', 'localStorage', 'navigator'],
            lookupFromPathIndex: 0,
            caches: ['localStorage']
        }
    });

export default i18n;
